import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import About from './Components/About';
import GraphicDesignBody from './Components/GraphicDesignBody_optimized';
// import './Components/App.css';





function App() {
  // Initialize AOS once for entire app (consolidates 24+ duplicate initializations)
  useEffect(() => {
    AOS.init({
      duration: 1250,
      once: true,
    });
  }, []);

  return (
    <div className="container-fluid h-100 g-0">
      <About />
      <GraphicDesignBody />
    </div>
  );
}

export default App;
